import { render, staticRenderFns } from "./slideshow.vue?vue&type=template&id=5adc333a&scoped=true"
import script from "./slideshow.vue?vue&type=script&lang=js"
export * from "./slideshow.vue?vue&type=script&lang=js"
import style0 from "./slideshow.vue?vue&type=style&index=0&id=5adc333a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adc333a",
  null
  
)

export default component.exports